import {Component, computed, input, output} from "@angular/core";
import {FontAwesomeCode} from "@models";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {NgTemplateOutlet} from "@angular/common";
import {MatRipple} from "@angular/material/core";

@Component({
	selector: "sim-list-item",
	templateUrl: "./list-item.component.html",
	styleUrl: "./list-item.component.scss",
	imports: [MatTooltip, MatIcon, NgTemplateOutlet, MatRipple],
	standalone: true,
})
export class ListItemComponent {
	// I/O
	public primaryLabel = input.required<string>();
	public secondaryLabel = input<string | null | undefined>();
	public secondaryLabelIcon = input<FontAwesomeCode | null>(null);
	public tooltip = input<string | null>(null);
	/** Is item currently selected? */
	public selected = input<boolean>(false);
	/** Determines whether this item can be selected in this use-case at all. If currently something prevents selection use *preventSelection* instead */
	public selectable = input<boolean>(true);
	/** Assuming the item is selectable, there might be a reason to prevent its selectability (e.g. other item in list is invalid) */
	public preventSelection = input<boolean>(false);
	public invalid = input<boolean>(false);
	public indicator = input<string | FontAwesomeCode | number | null>(null);

	public onClick = output<void>();

	// Properties
	public indicatorIcon = computed<FontAwesomeCode | null>(() => {
		if (typeof this.indicator() !== "object") {
			return null;
		}
		return this.indicator() as FontAwesomeCode;
	});
}
